// extracted by mini-css-extract-plugin
module.exports = {"overlay":"CommentTooltip_overlay__15esK"};